// extracted by mini-css-extract-plugin
export default {"container":"AdminEvents_container__5dJPs","tab-body":"AdminEvents_tab-body__Y50p-"};